import { isDepartmentValid } from './isDepatmentValid';
import { applyDepartmentFallbacks } from './applyDepartmentFallbacks';
import { mergeDepartmentInAddress } from './mergeDepartmentInAddress';
import { createDepartmentLocation } from './createDepartmentLocation';

/**
 * Processes a single department and adds or merges it into the addresses array
 *
 * @param {ADDDepartment} department - Department to process
 * @param {WidgetLocation[]} addresses - Array of existing addresses (mutated)
 * @param {WidgetLocation} defaultLocation - Default location for fallbacks
 * @param {ADDContactInformation} primaryContactInformation - Primary contact info
 * @returns {boolean} True if department was processed, false if skipped
 */
export const processDepartment = (
	department,
	addresses,
	defaultLocation,
	primaryContactInformation
) => {
	// Validate department
	if (!isDepartmentValid(department)) {
		return false;
	}

	// Apply fallbacks
	const normalizedDepartment = applyDepartmentFallbacks(
		department,
		defaultLocation,
		primaryContactInformation
	);

	// Try to merge with existing address
	const mergeResult = mergeDepartmentInAddress(
		addresses,
		normalizedDepartment,
		defaultLocation.phones[0]?.number || ''
	);

	// If successfully merged, we're done
	if (mergeResult.success) {
		return true;
	}

	// Create new department location
	const departmentLocation = createDepartmentLocation(
		department,
		normalizedDepartment,
		defaultLocation
	);

	addresses.push(departmentLocation);
	return true;
};
